(function ($, root, undefined) {

	$(function () {

		'use strict';

		$(document).on('ready', function () {

			/*====  side-widget-menu  =====*/
			$(document).on('click','.side-menu-wrap .side-menu-ul .sidenav__item .menu-plus-icon', function () {
				$(this).closest('.sidenav__item').siblings().removeClass('active').find('.side-sub-menu').slideUp(200);
				$(this).closest('.sidenav__item').toggleClass('active').find('.side-sub-menu').slideToggle(200);
				return false;
			});

			/*=========== Mobile Menu Open Control ============*/
	        $(document).on('click','.logo-right-button .side-menu-open', function () {
	            $('.side-nav-container').addClass('active');
	        });

	        /*=========== Mobile Menu Close Control ============*/
	        $(document).on('click','.humburger-menu .side-menu-close', function () {
	            $(".side-nav-container").removeClass('active');
	        });

		});


		$('#loading').delay('500').fadeOut(1300);

		$(document).on('click','#scroll-top', function () {
		  $('html, body').animate({scrollTop:0},1000);
		});

		var scrollButton = $('#scroll-top');

		$(window).on('scroll', function () {
		  //header fixed animation and control
		  if($(window).scrollTop() > 0) {
		      $('.header-menu-area').addClass('header-fixed');
		  }else{
		      $('.header-menu-area').removeClass('header-fixed');
		  }

		  //back to top button control
		  if($(this).scrollTop()>= 300){
		      scrollButton.show();
		  }else{
		      scrollButton.hide();
		  }
		});

		/*====  accordion  =====*/
		$(document).on('click', '.accordion__title', function () {
		  $(this).closest('.accordion-panel').siblings().removeClass('active').find('.accordion__content').slideUp(200);
		  $(this).closest('.accordion-panel').toggleClass('active').find('.accordion__content').slideToggle(200);
		  return false;
		});

		/*==== fancybox  =====*/
		$('[data-fancybox]').fancybox({
			// Options will go here
			buttons: [
				"zoom",
				"share",
				"slideShow",
				"fullScreen",
				"download",
				"thumbs",
				"close"
			],
			afterLoad : function(instance, current) {
		        /*
				var pixelRatio = window.devicePixelRatio || 2;
		        if ( pixelRatio > 1.5 ) {
		            current.width  = current.width  / pixelRatio;
		            current.height = current.height / pixelRatio;
		        }
				*/
			    current.width  = current.width * 10;
	            current.height = current.height * 10;
		    }
		});

		$.fancybox.defaults.animationEffect = "zoom";

	});


})(jQuery, this);
